<template>
    <page-card :header="$t('pages.datasync.title')">

        <div v-if="data.hasGroup">
            <callout callout-class="callout-success" icon="check">
                <p>{{ $t('pages.datasync.already_syncing') }}</p>
                <dl class="small">
                    <dt>{{ $t('pages.datasync.meta_group') }}</dt>
                    <dd>{{ this.data.metaGroup }}</dd>
                    <dt>{{ $t('pages.datasync.current_group') }}</dt>
                    <dd>{{ this.data.currentGroup }}</dd>
                </dl>
            </callout>
        </div>

        <div v-if="!data.hasGroup">
            <b-form @submit.prevent="" v-if="!data.hasGroup">
                <b-form-group :label="$t('pages.datasync.activate')"
                              label-for="activateDatasync">
                    <b-form-checkbox
                        id="activateDatasync"
                        v-model="accepted"
                        name="activateDatasync"
                        value="activate"
                        unchecked-value=""
                    >
                        {{ $t('pages.datasync.activate_disclaimer') }}
                    </b-form-checkbox>

                </b-form-group>
                <b-button-group class="d-flex">
                    <b-button variant="primary"
                              class="w-100"
                              id="datasyncActivateSubmit"
                              v-on:click="activateDatasync"
                              :disabled="!accepted"
                              :aria-disabled="!accepted">
                        {{ $t('pages.datasync.button_submit') }}
                    </b-button>
                </b-button-group>
            </b-form>
        </div>

    </page-card>
</template>
<script>
import GenericNotification from "../layout/GenericNotification";
import LoadingInjector from "../../mixins/LoadingInjector";
import PageCard from "../layout/PageCard";
import Callout from "../layout/Callout";


export default {
    mixins: [
        LoadingInjector
    ],
    components: {
        GenericNotification,
        PageCard,
        Callout,
    },
    props: {
        rzaccount: {
            required: true,
            type: String,
        }
    },

    data() {
        return {
            notifications: [],
            data: {},
            accepted: false,
        }
    },
    created() {
        this.errorHandler = this.$shared.errorHandlerForResponder;
    },
    mounted() {
        console.log('Mounted DataSync.');
        this.getStatus();
    },
    methods: {
        getStatus: function () {
            this.axios.get(this.$Bologna.secure_url(`/v1/accounting/datasync/${this.rzaccount}`), {})
                .then(response => {
                    this.data = response.data.data;
                })
                .catch(error => {

                });
        },
        activateDatasync: function () {
            this.axios.post(this.$Bologna.secure_url(`/v1/accounting/datasync/${this.rzaccount}`), {})
                .then(response => {
                    this.data.hasGroup = response.data.data.success;
                    this.data.supposedGroup = response.data.data.supposedGroup;
                    this.data.currentGroup = this.data.supposedGroup;
                    this.data.metaGroup = response.data.data.metaGroup;
                })
                .catch(error => {

                });
        }
    },
    computed: {}
};
</script>
